import Vue from 'vue';
import './plugins/element.js';
import App from './App.vue';
import './assets/scss/common.scss';
import router from './router'


new Vue({
  el: '#app',
  router,
  render: h => h(App)
});